// extracted by mini-css-extract-plugin
module.exports = {"read-or-hide":"ReadMore_read-or-hide__QrySp","description-text":"ReadMore_description-text__xBj8h"};